import React, { useState } from 'react';

import { Form, Input } from 'antd';

import { emailRegex } from '../../../utils/Validations';

const EmailField = (props) => {
  const form = Form.useFormInstance();

  const { email, setEmail, className, customeEmailError, clearCustomeEmailError } = props;
  const [wrongEmailError, setWrongEmailError] = useState(null);
  const handleSetEmail = (value) => {
    const trimmedEmail = value?.trim();
    customeEmailError && clearCustomeEmailError();
    setEmail(trimmedEmail);
    if (customeEmailError) {
      if (emailRegex.test(trimmedEmail)) {
        setWrongEmailError(null);
      } else {
        setWrongEmailError('Enter a valid email address.');
      }
    }

    form?.setFieldValue('email', value?.trim());
  };
  return (
    <Form.Item
      validateTrigger='onBlur'
      className={className}
      validateStatus={customeEmailError && (customeEmailError || wrongEmailError) && 'error'}
      help={customeEmailError && (wrongEmailError || customeEmailError)}
      name='email'
      rules={[
        {
          required: true,
          type: 'email',
          message: !customeEmailError && 'Enter a valid email address.',
        },
      ]}
    >
      <Input id='email' value={email} onChange={(e) => handleSetEmail(e.target.value)} />
    </Form.Item>
  );
};

export default EmailField;
